import React from "react";
import Carousel from "better-react-carousel";

const Carousal1 = () => {
  return (
    <Carousel cols={6} rows={1} gap={10} loop>
      <Carousel.Item>
        <img
          width="auto"
          src="https://images-static.nykaa.com/uploads/9716ea78-057b-46c1-a5a6-72e0741c71b8.jpg?tr=w-240,cm-pad_resize"
          alt="something went wrong"
        />
        <p
          style={{
            backgroundColor: "lightGrey",
            fontWeight: "normal",
            textAlign: "center",
            color: "black",
            padding: "5px",
          }}
        >
          Trending 10 Fragrances
        </p>
      </Carousel.Item>
      <Carousel.Item>
        <img
          width="auto"
          src="https://images-static.nykaa.com/uploads/a75736c9-793c-4e69-9dce-558bcd011968.jpg?tr=w-240,cm-pad_resize"
          alt="something went wrong"
        />
        <p
          style={{
            backgroundColor: "lightGrey",
            fontWeight: "normal",
            textAlign: "center",
            color: "black",
            padding: "5px",
          }}
        >
          Pantone Color '23
        </p>
      </Carousel.Item>
      <Carousel.Item>
        <img
          width="auto"
          src="https://images-static.nykaa.com/uploads/92447a8b-4cbc-4cfa-9c65-818137cbddf7.jpg?tr=w-240,cm-pad_resize"
          alt="something went wrong"
        />
        <p
          style={{
            backgroundColor: "lightGrey",
            fontWeight: "normal",
            textAlign: "center",
            color: "black",
            padding: "5px",
          }}
        >
          Bridal Makeu
        </p>
      </Carousel.Item>
      <Carousel.Item>
        <img
          width="auto"
          src="https://images-static.nykaa.com/uploads/c01444d8-5b41-43af-b11c-a63fc9d4d5a6.jpg?tr=w-240,cm-pad_resize"
          alt="something went wrong"
        />
        <p
          style={{
            backgroundColor: "lightGrey",
            fontWeight: "normal",
            textAlign: "center",
            color: "black",
            padding: "5px",
          }}
        >
          2022 Winners
        </p>
      </Carousel.Item>
      <Carousel.Item>
        <img
          width="auto"
          src="https://images-static.nykaa.com/uploads/2e8f18d5-06d0-4aab-8d8e-7644aa54023f.jpg?tr=w-240,cm-pad_resize"
          alt="something went wrong"
        />
        <p
          style={{
            backgroundColor: "lightGrey",
            fontWeight: "normal",
            textAlign: "center",
            color: "black",
            padding: "5px",
          }}
        >
          Weight Management
        </p>
      </Carousel.Item>

      <Carousel.Item>
        <img
          width="auto"
          src="https://images-static.nykaa.com/uploads/4ea35342-cbb3-44ef-a556-9f1c0f749d93.jpg?tr=w-240,cm-pad_resize"
          alt="something went wrong"
        />
        <p
          style={{
            backgroundColor: "lightGrey",
            fontWeight: "normal",
            textAlign: "center",
            color: "black",
            padding: "5px",
          }}
        >
          Foundations
        </p>
      </Carousel.Item>
      <Carousel.Item>
        <img
          width="auto"
          src="https://images-static.nykaa.com/uploads/4162f650-31a3-4d41-a420-ac02caccce89.jpg?tr=w-240,cm-pad_resize"
          alt="something went wrong"
        />
        <p
          style={{
            backgroundColor: "lightGrey",
            fontWeight: "normal",
            textAlign: "center",
            color: "black",
            padding: "5px",
          }}
        >
          Highlighters
        </p>
      </Carousel.Item>
      <Carousel.Item>
        <img
          width="auto"
          src="https://images-static.nykaa.com/uploads/b2df2716-c39d-40a7-b2a5-76c728a2590b.jpg?tr=w-240,cm-pad_resize"
          alt="something went wrong"
        />
        <p
          style={{
            backgroundColor: "lightGrey",
            fontWeight: "normal",
            textAlign: "center",
            color: "black",
            padding: "5px",
          }}
        >
          Feminine Hygiene
        </p>
      </Carousel.Item>
      <Carousel.Item>
        <img
          width="auto"
          src="https://images-static.nykaa.com/uploads/fdc3b122-62f6-436e-ab58-e4a2c5a253e3.jpg?tr=w-240,cm-pad_resize"
          alt="something went wrong"
        />
        <p
          style={{
            backgroundColor: "lightGrey",
            fontWeight: "normal",
            textAlign: "center",
            color: "black",
            padding: "5px",
          }}
        >
          Beauty Supplements
        </p>
      </Carousel.Item>
    </Carousel>
  );
};

export default Carousal1;
